export default __webpack_public_path__ + "static/forecast-modeling-50eab0e0bc6b5f15b3fc4ee2a8a330b8.mp4";